import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SSIHoverTextTextStyled as Text, SSIHoverTextContainerStyled as Container, SSIHoverTextTextHoverStyled as TextHover, } from '../../../styles/components';
const SSIHoverText = (props) => {
    const { text, truncationLength, enableHover = true } = props;
    const value = truncationLength ? text.substring(0, truncationLength) : text;
    return (_jsxs(Container, { children: [_jsx(Text, { children: value }), enableHover && _jsx(TextHover, { children: text })] }));
};
export default SSIHoverText;
